import React, { createContext, useState, useMemo } from "react";

export const ReportContext = createContext();

export const ReportProvider = ({ children }) => {
  const [reportData, setReportData] = useState([]);
  const [staffData, setStaffData] = useState([]);
  const resetData = () => {
    setReportData([]);
    setStaffData([]);
  };

  const contextObj = useMemo(
    () => ({
      reportData,
      setReportData: setReportData,
      resetData: resetData,
      staffData,
      setStaffData,
    }),
    [reportData, staffData]
  );

  return <ReportContext.Provider value={contextObj}>{children}</ReportContext.Provider>;
};
